export var TransportMode;
(function (TransportMode) {
    TransportMode["Car"] = "car";
    TransportMode["PublicTransport"] = "public_transport";
})(TransportMode || (TransportMode = {}));
